<img *ngIf="src" [src]="src" [style.width]="size$ | async" />
